export default "__VITE_ASSET__BPug2vir__"